import { createFileRoute } from "@tanstack/react-router";
import { classSessionSearchSchema } from "./-lib/search-schema";



export const Route = createFileRoute("/_protected/class-sessions/")({
  head: () => ({
    meta: [{ title: "班期管理 · imiker CRM" }],
  }),
  validateSearch: classSessionSearchSchema
});
